import FormModal from 'components/organisms/FormModal/FormModal'
import * as FormConst from 'constants/FormConst'
import React, { Component } from 'react'
import DashboardSummaryService from 'services/DashboardSummaryService'
import { isArrayNotEmpty } from '../../utilities/JSUtil'
import './DashboardSummary.scss'

class DashboardSummary extends Component {

    constructor(props) {
        super(props)

        this.state = {
            user: this.props.user,
            dashboardSummary: [],
            isLoading: true,
            showErrorModal: false
        }
    }

    async componentDidMount() {

        let summaryDetails = {}
        for (const status in FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS) {
            if (Object.hasOwnProperty.call(FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS, status)) {
                const displayStatus = FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[status];
                summaryDetails[displayStatus] = 0
            }
        }

        await DashboardSummaryService.getDashboardSummary()
            .then((response) => {

                if (isArrayNotEmpty(response.hotelOnboardingDashboardSummaryDetails)) {
                    response.hotelOnboardingDashboardSummaryDetails.forEach((entry) => {
                        summaryDetails[FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[entry.status]] += entry.count
                    })
                }

                let dashboardSummary = []

                for (const displayStatus in summaryDetails) {
                    if (Object.hasOwnProperty.call(summaryDetails, displayStatus)) {
                        const count = summaryDetails[displayStatus];
                        dashboardSummary.push({
                            status: displayStatus,
                            count: count
                        })
                    }
                }

                this.setState({
                    dashboardSummary: dashboardSummary,
                    isLoading: false
                })
            })
            .catch((error) => {
                this.setState({
                    isLoading: false, showErrorModal: true
                })
            })
    }

    render() {
        return (
            <>
                {
                    isArrayNotEmpty(this.state.dashboardSummary) &&
                    <div className='dashboard-summary'>
                        <table className='table table-striped dashboard-summary-table'>
                            <caption className='caption-title'>Status Dashboard</caption>
                            {/* <caption>This is a count of the existing onboarding applications by status</caption> */}
                            <thead>
                                <tr>
                                    <th>Status</th>
                                    <th>Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.dashboardSummary.map((entry, index) => {
                                        return <tr key={index}>
                                            <td>{entry.status}</td>
                                            <td>{entry.count}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                }
                <FormModal
                    id='dashboard-summary-loading-modal'
                    title={FormConst.MODAL_READ_ACTION_TITLE}
                    body={<h6>{FormConst.MODAL_DASHBOARD_READ_ACTION_TEXT}</h6>}
                    show={this.state.isLoading}
                    isLoadingIndicator />
                <FormModal
                    id='dashboard-summary-error-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                    body={<h5>{FormConst.MODAL_DASHBOARD_ERROR_TEXT}</h5>}
                    isError
                    show={this.state.showErrorModal}
                    cancel={() => {
                        this.setState({
                            showErrorModal: false
                        })
                    }} />
            </>
        )
    }
}

export default DashboardSummary